// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__25Kuz","col":"styles_col__1l84d","fulfillmentStatus":"styles_fulfillmentStatus__2kqjf","emailCol":"styles_emailCol__lyptf"};